import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import SegmentForm from "./SegmentForm";
import {GetFields} from "./GetFields";


const SegmentEdit = ({audience, id_segment}) => {

    const [errors, setErrors] = useState()
    const [segment, setSegment] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [queryFields, setQueryFields] = useState([])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/audiences/${audience?._id?.$oid}/segments/upsert/${id_segment}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Segment has been successfully updated')
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }



    useEffect(() => {
        const response = GetFields({audience, id_segment})
        setSegment(response.segment)
        setQueryFields(response.fields)
        setIsLoading(false)
    }, [])


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-720">
                            <SegmentForm
                                audience={audience}
                                errors={errors}
                                segment={segment}
                                fields={queryFields}
                                isReady={!isLoading}
                                onSubmit={handleUpdate}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default SegmentEdit